import { createUseStyles } from 'react-jss'
import { LightTheme } from '../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  modalContainer: {},
  container: {
    backgroundColor: theme.colors.white,
    padding: '24px 0 56px'
  },
  name: {
    padding: '8px 0'
  },
  image: {
    width: '100%',
    maxHeight: 312,
    objectFit: 'cover'
  },
  column: {},
  title: {
    marginTop: 24
  },
  text: {
    marginTop: 24
  },
  buttonRow: {
    marginTop: 24
  },
  '@media screen and (max-height: 640px)': {
    modalContainer: {
      maxWidth: 480
    },
    container: {
      backgroundColor: theme.colors.white,
      padding: '24px 0'
    },
    image: {
      width: 'calc(100% - 160px)',
      maxHeight: 200,
      padding: '0 16px'
    },
    title: {
      marginTop: 0
    },
    text: {
      textAlign: 'center',
      marginTop: 16
    },
    column: {
      padding: '0 16px',
      width: 'calc(100% - 32px)'
    }
  },
  '@media screen and (max-width: 480px)': {
    image: {
      width: 'calc(100% - 32px)',
      maxHeight: 182,
      padding: 16
    },
    column: {
      width: 'calc(100% - 32px)',
      padding: '0 16px 16px'
    },
    title: {
      marginTop: 16
    },
    text: {
      marginTop: 8,
      textAlign: 'center'
    }
  }
}))
